import React, { useEffect, useState } from "react";

import { buttonVariants } from "./button";
import ToolTipNavItem from "./tooltip-nav-item";

function QuranAyahShowTafsir() {
  return (
    <ToolTipNavItem tooltipText="Tafsir" direction="top">
      <div
        className={`${buttonVariants({
          variant: "bgGhost",
        })} h-9 w-9 p-0 cursor-pointer`}
      >
        {/* <BookOpenText className="w-5 h-5" /> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-5 h-5"
        >
          <path d="M12 7v14"></path>
          <path d="M16 12h2"></path>
          <path d="M16 8h2"></path>
          <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
          <path d="M6 12h2"></path>
          <path d="M6 8h2"></path>
        </svg>
      </div>
    </ToolTipNavItem>
  );
}

export default QuranAyahShowTafsir;

